import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import loading from './loading';
import work from './work';
import header from './header';
import skills from './skills';
import contact from './contact';
import bio from './bio';

const rootReducer = combineReducers({
  loading,
  work,
  header,
  skills,
  form: formReducer,
  contact,
  bio
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js